import { forwardRef, PropsWithChildren } from "react";
import { classNames } from "zeta-dom-react";
import { extend } from "zeta-dom/util";

function TabularListItem(props: PropsWithChildren<{ label: string, className?: string, variant?: 'paragraph' }>) {
    return (
        <>
            <dt className={classNames(props.className, { variant: props.variant })}>{props.label}</dt>
            <dd className={classNames(props.className, { variant: props.variant })}>{props.children || '-'}</dd>
        </>
    );
}

export const TabularList = extend(
    forwardRef<HTMLDListElement, React.ComponentPropsWithRef<'dl'>>((props, ref) => {
        return (
            <dl ref={ref} {...props} className={classNames('eac-tabular-list', props.className)}></dl>
        );
    }),
    { Item: TabularListItem });
